import { Component } from '@angular/core';
import { LocalStorageService } from '../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';

@Component({
    selector: 'kiene-kontenrahmen-layout',
    templateUrl: './kontenrahmen-layout.component.html',
    styleUrls: ['./kontenrahmen-layout.component.scss'],
})
export class KontenrahmenLayoutComponent {
    constructor(private localStorageService: LocalStorageService) {}

    isTabMenuVisible(path: string) {
        return this.localStorageService.currentUserCanSeeTab(path);
    }
}
